import { RCTProductHeaderContainer } from './RCTProductsHeader.styles';
import Heading from '@legacy-vfuk/core-heading';
import Button from '@legacy-vfuk/core-button';
import { ProductBundle } from '@/types/Product.types';
import { InteractionEvent } from '@uk-source-web/interaction';
import { handleScrollToSection } from '@/helpers/GlobalEvents';
import handleTranslation from '@/helpers/handleTranslation';

export const RCTProductRow = ({ product }: { product: ProductBundle }) => {
  const defaultTypename = ['ContentfulSectionCardDisplay', 'ContentfulSectionSwPricingContent', 'SWSectionTariffCards'];

  const handleBuyClick = (e: InteractionEvent) => {
    handleScrollToSection(defaultTypename);
  };
  const configureAndBuy = handleTranslation('Configure and buy','Aderir');
  return (
    <RCTProductHeaderContainer>
      <Heading level={5} text={product.name} weight={4} />
      <Button text={configureAndBuy} width="full" onClick={e => handleBuyClick(e)} />
    </RCTProductHeaderContainer>
  );
};
